export enum PermissionRoles {
  VOLUMETRY_REGION_ADMIN = 'VOLUMETRY_REGION_ADMIN'
}
